"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const themed_1 = require("@rneui/themed");
const App_1 = __importDefault(require("./App"));
const theme = (0, themed_1.createTheme)({
    lightColors: {
        primary: '#e7e7e8',
    },
    darkColors: {
        primary: '#000',
    },
    mode: 'dark',
});
const Index = () => {
    return (react_1.default.createElement(react_native_safe_area_context_1.SafeAreaProvider, null,
        react_1.default.createElement(themed_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(App_1.default, null))));
};
exports.default = Index;
